import { useAuth } from '../contexts/AuthContext';

interface HeaderProps {
    onMenuClick: () => void;
}

function Header({ onMenuClick }: HeaderProps) {
    const { user, logout } = useAuth();

    const handleLogout = async () => {
        await logout();
    };

    return (
        <header className="bg-dark shadow-lg border-b border-zinc-700">
            <div className="flex items-center justify-between px-6 py-4">
                <div className="flex items-center">
                    <button
                        onClick={onMenuClick}
                        className="text-white hover:text-logwatch-blue focus:outline-none focus:text-logwatch-blue mr-4"
                        aria-label="Toggle filters sidebar"
                        title="Toggle filters"
                    >
                        <i className="fas fa-filter text-xl"></i>
                    </button>

                    <h1 className="text-2xl font-bold text-white">
                        <i className="fas fa-file-alt text-logwatch-blue mr-2"></i>
                        Logwatch
                    </h1>
                </div>

                <div className="flex items-center space-x-4">
                    <span className="text-sm text-zinc-400 hidden md:block">ClickHouse Log Viewer</span>
                    <div className="flex items-center space-x-2">
                        <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                        <span className="text-xs text-green-500 hidden sm:block">Connected</span>
                    </div>

                    {/* User menu */}
                    <div className="flex items-center space-x-3 border-l border-zinc-700 pl-4">
                        <div className="flex items-center space-x-2">
                            <div className="w-8 h-8 bg-logwatch-blue rounded-full flex items-center justify-center">
                                <i className="fas fa-user text-white text-sm"></i>
                            </div>
                            <span className="text-sm text-white hidden md:block">{user?.username}</span>
                        </div>
                        <button
                            onClick={handleLogout}
                            className="text-zinc-400 hover:text-white focus:outline-none focus:text-white transition-colors"
                            aria-label="Logout"
                            title="Logout"
                        >
                            <i className="fas fa-sign-out-alt text-lg"></i>
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;
